import React, { useEffect, useMemo, useState } from 'react'
import i18n from 'simple-react-i18n'
import { getLocalStorageJson } from '../../../utils/FormUtils'
import Card from '../../../components/card/Card'
import Select from '../../../components/forms/Select'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import validateImg from '../../../assets/pictures/pictos/validate.png'
import purgeImg from '../../../assets/pictures/pictos/purge.png'
import importImg from '../../../assets/pictures/pictos/import.png'
import compensationImg from '../../../assets/pictures/pictos/compensation.png'
import correctionImg from '../../../assets/pictures/pictos/correction.png'
import optionsImg from '../../../assets/pictures/pictos/options.png'
import thresholdImg from '../../../assets/pictures/pictos/threshold.png'
import eventImg from '../../../assets/pictures/pictos/event.png'
import { isNull, keys, min, minBy } from 'lodash'
import { getLinks, getStationTitleWithTownName } from '../../../utils/StationUtils'
import HydrometryAction from '../../actions/HydrometryAction'
import ValidationHydroToolPanel2 from './tools/ValidationHydroToolPanel2'
import TableViewValidationHydroMode2 from './displayMode/TableViewValidationHydroMode2'
import GraphicValidationHydroMode from './displayMode/GraphicValidationHydroMode'
import useTitle from '../../../utils/customHook/useTitle'
import { EVENT, IMPORT } from '../../../home/constants/RouteConstants'
import { THRESHOLDS } from '../../../alerting/constants/AlertConstants'
import MessageCard from '../../../components/card/MessageCard'
import SimpleOptionsToolPanel from 'piezometry/components/validation/tools/SimpleOptionsToolPanel'
import moment from 'moment'
import DeleteHydroToolPanel from './tools/DeleteHydroToolPanel'
import EventsToolPanelHydro from './tools/EventsToolPanelHydro'
import {
    COMPENSATION,
    CORRECTION,
    DELETE,
    HYDRO_DISPLAY_COTE,
    HYDRO_L_STORAGE,
    HYDRO_MEASURE_COTE,
    HYDRO_TAB_DISPLAY_MODES,
    HYDRO_TYPEID,
    OPTIONS,
    PURGE,
    RESET,
    VALIDATION,
    WINDOW,
} from '../../constants/HydrometryConstants'
import { getFullDate } from '../../../utils/DateUtil'
import useMeasureTempRef from '../../../utils/customHook/useMeasureTempRef'
import ChartTempRefChip from '../../../components/echart/ChartTempRefChip'
import EventsAction from '../../../events/actions/EventsAction'
import CompensationHydroToolPanel from './tools/CompensationHydroToolPanel'
import CorrectionHydroToolPanel from './tools/CorrectionHydroToolPanel'
import ToastrAction from '../../../toastr/actions/ToastrAction'
import ThresholdsTab from '../../../alerting/components/dashboard/tabPopin/ThresholdsTab'
import Checkbox from '../../../components/forms/Checkbox'
import AdministrationAction from '../../../administration/actions/AdministrationAction'
import ContributorAction from '../../../referencial/components/contributor/actions/ContributorAction'
import ImportHydroToolPanel from './tools/ImportHydroToolPanel'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { H_STATION_HYDRO_VALIDATION } from '../../../account/constants/AccessRulesConstants'
import { push } from '@lagunovsky/redux-react-router'
import { getStationArrowNav } from '../../../utils/ActionUtils'
import useUpdateEffect from '../../../utils/customHook/useUpdateEffect'
import { CardContent, Grid, Tooltip } from '@mui/material'
import HydrometerStationAction from 'station/actions/HydrometerStationAction'
import { hasValue } from 'utils/NumberUtil'
import {
    AUTO_Y_SCALE,
    CHART_SELECTED_TIME,
    CHART_SELECTED_TIME_OTHER,
    MANUAL_Y_SCALE,
    OTHER,
} from 'quality/constants/ChartConstant'
import ProgressCard from 'components/card/ProgressCard'
import MUIChartTabs from 'components/echart/MUIChartTabs'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import { HISTO, J90 } from 'alerting/constants/ChartFollowContants'
import useActions from 'utils/customHook/useActions'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'
import useLocalStorage from '../../../utils/customHook/useLocalStorage'
import SimpleChartTabsHydro from '../../../components/echart/SimpleChartTabsHydro'
import { getChartDate, getSubstractTime } from 'components/echart/EChartUtils'
import { getQualificationSelectOptions, getStatusSelectOptions } from 'utils/StatusUtil'
import { FormatListBulleted, MultilineChart } from '@mui/icons-material'
import SuperMultiAutocomplete from '../../../components/forms/SuperMultiAutocomplete'
import Other from '../../../components/actions/Other'
import IconTool from 'components/icon/IconTool'
import { getNGFDepth, getNGFDepthAtDate } from 'utils/HydroUtils'

const PERSONALIZED_GROUPING = 'personalizedGrouping'

const listView = [VALIDATION, PURGE, EVENT, THRESHOLDS]

const HydrometryValidationApp = ({}) => {
    const {
        hydrometricStation,
        hydrometricStations,
        hydroMeasures,
        hydrometryDataTypes,
        hydroStatistics,
        hydrometryThresholds,
        applicationSettings,
        contributors,
        lastMeasureHydro,
        hydrometerChartOptions,
        typeEnvironmentModels,
        citiesIndex,
    } = useSelector(store => ({
        hydrometricStation: store.HydrometryReducer.hydrometricStation,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
        hydroMeasures: store.HydrometryReducer.hydroMeasures,
        hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
        hydroStatistics: store.HydrometryReducer.hydroStatistics,
        hydrometryThresholds: store.HydrometryReducer.hydrometryThresholds,
        applicationSettings: store.AdministrationReducer.applicationSettings,
        contributors: store.ContributorReducer.contributors,
        lastMeasureHydro: store.HydrometryReducer.hydroLastMeasures,
        hydrometerChartOptions: store.HydrometerStationReducer.chartOptions,
        typeEnvironmentModels: store.ExportReducer.typeEnvironmentModels,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const lastTime = useAccountSetting(CHART_SELECTED_TIME, v => [HISTO, OTHER].includes(v) ? v : (v ? parseInt(v) : J90))
    const lastSelectedTime = lastTime !== 'HISTO' ? lastTime : J90
    const lastSelectedTimeOther = getLocalStorageJson(CHART_SELECTED_TIME_OTHER)
    const getDefaultMinDate = () => {
        if (lastSelectedTime === OTHER) {
            return lastSelectedTimeOther.minDate
        }
        return lastSelectedTime === HISTO ? undefined : getSubstractTime(lastSelectedTime)
    }
    const getDefaultMaxDate = () => {
        if (lastSelectedTime === OTHER) {
            return lastSelectedTimeOther.maxDate
        }
        return lastSelectedTime === HISTO ? moment().valueOf() : undefined
    }

    const [time, setTime] = useState(lastSelectedTime || J90)
    const [dataType, setDataType] = useState(null)
    const [selectedCodePoint, setSelectedCodePoint] = useState(null)
    const [tableView, setTableView] = useState(false)
    const [tool, setTool] = useState(VALIDATION)
    const [selection, setSelection] = useState(WINDOW)
    const [selectionData, setSelectionData] = useState()
    const [dataLoaded, setDataLoaded] = useState(false)
    const [startDate, setStartDate] = useState(undefined)
    const [endDate, setEndDate] = useState(undefined)
    const [minDate, setMinDate] = useState(getDefaultMinDate())
    const [maxDate, setMaxDate] = useState(getDefaultMaxDate())
    const [tempRef, setTempRef] = useLocalStorage(HYDRO_L_STORAGE.TEMP_REF, undefined)
    const stationTempRefOffset = useMeasureTempRef(hydrometricStation?.link_tempRefs, dataType)
    const tempRefOffset = useMeasureTempRef(hydrometricStation?.link_tempRefs, dataType, tempRef)
    const [value, setValue] = useState()
    const [initialPoint, setInitialPoint] = useState()
    const [isChange, setIsChange] = useState(false) // sert à recharger les données (ex: import manuel, correction, compensation, etc...), redéclanche le fetch dans le useEffect
    const [isPreview, setIsPreview] = useState(false)
    const [isThresholShow, setIsThresholShow] = useState(true)
    const [serieLinePrevious, setSerieLinePrevious] = useState([])
    const [graphicOptions, setGraphicOptions] = useState({})
    const [valueCorrection, setValueCorrection] = useState(1)
    const [measuresChangesValidation, setMeasuresChangesValidation] = useState([])
    const [validationFilterFullDay, setValidationFilterFullDay] = useLocalStorage('VALIDATE_FULL_DATE', false)
    const [selectFilters, setSelectFilters] = useState({})
    const changeSelectFilters = changes => setSelectFilters({ ...selectFilters, ...changes })

    const [displayCote, setDisplayCote] = useLocalStorage(HYDRO_DISPLAY_COTE, HYDRO_MEASURE_COTE.HEIGHT)
    const [displayModes, setDisplayModes] = useLocalStorage(HYDRO_TAB_DISPLAY_MODES, {
        auto: true,
        max: false,
        min: false,
        average: false,
        brute: false,
        initialBrute: false,
    })
    const [accuracy, setAccuracy] = useState({
        qualifications: getQualificationSelectOptions().map(q => q.code),
        status: getStatusSelectOptions().map(s => s.code),
    })

    const dispatch = useDispatch()

    const townName = useMemo(() => citiesIndex[hydrometricStation.townCode]?.name, [citiesIndex, hydrometricStation])

    useTitle(() => [{
        title: i18n.hydrometry,
        href: 'hydrometry',
    }, {
        title: getStationTitleWithTownName(hydrometricStation, townName),
        href: `station/hydrometry/${hydrometricStation.id}`,
    }, {
        title: i18n.validation,
        href: `station/hydrometry/${hydrometricStation.id}/validationHydro`,
    }], [hydrometricStation.id, townName])

    const getIntegrationOverviewLink = () => (
        { other: <Other
            className='clickable'
            onClick={() => dispatch(push('/hydrometry/integrationOverview'))}
            tooltip={i18n.integrationOverview}
            icon='traffic'
        /> })


    useActions(() => ({
        arrowNav: getStationArrowNav(
            'hydrometry',
            hydrometricStations,
            hydrometricStation.id, s => dispatch(push(`/station/hydrometry/${s.id}/validationHydro`)),
        ),
        links: getLinks(hydrometricStation),
        exportmodel: () => ({
            stationId: hydrometricStation.id.toString(),
            stationCode: hydrometricStation.code,
            stationType: hydrometricStation.typeName,
            environmentModels: typeEnvironmentModels,
        }),

        other: getIntegrationOverviewLink(),
    }), [hydrometricStation.id, hydrometricStations])

    useEffect(() => {
        if (!componentHasHabilitations(H_STATION_HYDRO_VALIDATION)) {
            dispatch(push('/unauthorized'))
        }
    }, [])

    const { isLoaded, progress } = useProgressDispatch(() => {
        const promises = !hydrometricStations.length ? [HydrometryAction.fetchHydrometricStations] : []
        const promisesDataType = !hydrometryDataTypes.length ? [...promises, HydrometryAction.fetchHydrometryDataTypes] : promises
        const promisesThresholds = !hydrometryThresholds.length ? [...promisesDataType, HydrometryAction.fetchHydrometricThresholds] : promisesDataType
        const promisesSettings = !applicationSettings.length ? [...promisesThresholds, AdministrationAction.fetchApplicationSettings] : promisesThresholds
        const promisesContribs = !contributors.length ? [...promisesSettings, ContributorAction.fetchContributors] : promisesSettings
        return promisesContribs.map(p => dispatch(p()))
    }, [])

    const setGraphicOptionsTypeId = (chartOptions, typeId) => {
        const prevGraphicOptions = chartOptions.find(co => co.dataType === `${typeId}`) || {}
        setGraphicOptions({
            minY: prevGraphicOptions.minYear,
            maxY: prevGraphicOptions.maxYear,
            yChoice: (hasValue(prevGraphicOptions.minYear) || hasValue(prevGraphicOptions.maxYear)) ? MANUAL_Y_SCALE : AUTO_Y_SCALE,
            yIntervalNb: prevGraphicOptions.intervalYear,
            showXSplitLines: prevGraphicOptions.displayXIntervalYear,
            showYSplitLines: prevGraphicOptions.displayYIntervalYear,
        })
    }

    useEffect(() => {
        dispatch(HydrometryAction.fetchHydroLastMeasures([hydrometricStation.id]))
        dispatch(HydrometryAction.fetchHydroStatistics(hydrometricStation.id)).then(stats => {
            const newDataType = hasValue(stats[0]?.typeId) ? stats[0]?.typeId : HYDRO_TYPEID.HEIGHT
            setDataType(newDataType)
            setSelectedCodePoint(hydrometricStation.link_pointPrels.filter(p => p.typeId === newDataType)[0]?.point)
            dispatch(HydrometerStationAction.fetchHydrometerChartOptions(hydrometricStation.id, chartOptions => setGraphicOptionsTypeId(chartOptions, newDataType)))
        })
    }, [hydrometricStation.id])

    const fetchThresholds = () => {
        dispatch(HydrometryAction.fetchHydrometricThresholds())
    }

    useUpdateEffect(() => {
        if (startDate > endDate && startDate && tableView) {
            setStartDate(endDate)
            setEndDate(startDate)
        }
    }, [startDate, endDate])

    useEffect(() => {
        if (isLoaded && dataType) {
            setDataLoaded(false)
            setGraphicOptionsTypeId(hydrometerChartOptions, dataType)
            // les brutes initiales sont une courbe supplémentaire, pas un mode de regroupement
            const groupModeFunc = keys(displayModes).find(mode => !['initialBrute', 'personalizedGroupingValue'].includes(mode) && displayModes[mode]) ?? 'auto'
            const defaultGroupMode = [90, 365, 'HISTO', 'OTHER'].includes(time) ? 'MAX' : 'all'
            const groupFunc = groupModeFunc === 'auto' ? defaultGroupMode : groupModeFunc
            dispatch(HydrometryAction.loadHydroChronicMeasures([{
                stationId: hydrometricStation.id,
                dataType,
                // displayCote, -> A remettre quand le back sera fait
                groupFunc: groupModeFunc === PERSONALIZED_GROUPING ? displayModes.personalizedGroupingValue : groupFunc.toUpperCase(),
                startDate: minDate,
                endDate: maxDate,
                status: accuracy.status,
                qualifications: accuracy.qualifications,
                codepoint: selectedCodePoint,
                tempRefOffsetHours: tempRefOffset,
            }])).then(() => {
                setDataLoaded(true)
            })
        }
    }, [isLoaded, dataType, time, isChange, displayModes, displayCote, accuracy, selectedCodePoint, tempRefOffset])

    const hydroMeasuresFormat = useMemo(() => hydroMeasures[0]?.measures || [], [hydroMeasures])

    const [sensorValues, setSensorValues] = useState([])
    useEffect(() => {
        if (tableView && dataLoaded && dataType) {
            dispatch(HydrometryAction.fetchHydroSensorValues({
                stationId: hydrometricStation.id,
                dataType,
                startDate: minDate,
                endDate: maxDate,
                codepoint: selectedCodePoint,
            })).then(setSensorValues)
        }
    }, [tableView, dataLoaded, hydroMeasures])

    const hydroDataTypes = useMemo(() => {
        return hydrometryDataTypes.map(v => ({
            id: v.id,
            label: v.label,
        }))
    }, [hydrometryDataTypes])

    const landmarkValue = useMemo(() => getNGFDepth(hydrometricStation), [hydrometricStation])

    const useNGF = useMemo(() => {
        if (!hydroStatistics.length || !dataType || displayCote !== HYDRO_MEASURE_COTE.NGF) {
            return false
        }
        const stat = hydroStatistics.find(s => s.typeId === dataType)
        return (stat.chronicFollowUp || stat.typeId === HYDRO_TYPEID.HEIGHT) && landmarkValue !== 0
    }, [dataType, hydroStatistics, landmarkValue, displayCote])

    const createTechnicalEvent = (toolState) => {
        const getDates = () => `${i18n.fromDate} ${getFullDate(startDate)} ${i18n.to} ${getFullDate(endDate)}`
        const eventProps = (() => {
            switch (toolState.mode) {
                case PURGE:
                    return {
                        comment: `${i18n.purge} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                case RESET:
                    return {
                        comment: `${i18n.reseting} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                case DELETE:
                    return {
                        comment: `${i18n.deleteAction} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                case VALIDATION:
                    return {
                        comment: `${i18n.validation} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                case COMPENSATION:
                    return {
                        comment: `${i18n.compensation} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                case CORRECTION:
                    return {
                        comment: `${i18n.appliedCorrections} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                case IMPORT:
                    return {
                        comment: `${i18n.importName} ${getDates()}\n`,
                        problem: JSON.stringify({
                            tool,
                        }),
                    }
                default:
                    return { comment: '' }
            }
        })()

        const newEvent = {
            eventType: 'T',
            date: moment().valueOf(),
            eventHour: moment().valueOf(),
            startDate,
            endDate,
            graph: '1',
            ...eventProps,
        }
        dispatch(EventsAction.addEvent('hydrometry', hydrometricStation.id, newEvent))
    }

    const measuresSelectedByFilters = useMemo(() => {
        if ([VALIDATION, PURGE].includes(tool)) {
            const landmarkToAdd = (m) => useNGF ? (getNGFDepthAtDate(hydrometricStation, m.date) ?? landmarkValue) : 0
            const withStatus = (m) => hasValue(selectFilters.filterStatus) ? m.status === parseInt(selectFilters.filterStatus) : true
            const withQualification = (m) => hasValue(selectFilters.filterQualification) ? m.qualification === selectFilters.filterQualification : true
            const withSuperior = (m) => hasValue(selectFilters.filterSuperior) ? m.value + landmarkToAdd(m) > selectFilters.filterSuperior : true
            const withInferior = (m) => hasValue(selectFilters.filterInferior) ? m.value + landmarkToAdd(m) < selectFilters.filterInferior : true
            const withProducer = (m) => hasValue(selectFilters.filterProducer) ? m.producer === selectFilters.filterProducer : true
            const withManager = (m) => hasValue(selectFilters.filterManager) ? m.manager === selectFilters.filterManager : true
            const withValidator = (m) => hasValue(selectFilters.filterValidator) ? m.validator === selectFilters.filterValidator : true

            return hydroMeasuresFormat.filter(m => m.date >= startDate && m.date <= endDate && withStatus(m) && withQualification(m) && withSuperior(m) && withInferior(m) && withProducer(m) && withManager(m) && withValidator(m))
        }
        return hydroMeasuresFormat.filter(m => m.date >= startDate && m.date <= endDate)
    }, [hydroMeasuresFormat, startDate, endDate, selectFilters, tool, useNGF, landmarkValue])

    const nextMeasure = useMemo(() => {
        return hydroMeasuresFormat.find(p => p.date > endDate)
    }, [hydroMeasuresFormat, endDate])

    const filteredTypesList = useMemo(() => {
        return hydrometryDataTypes
            .filter(dt => hydroStatistics.map(s => s.typeId).includes(dt.id))
            .map(dt => ({
                id: dt.id,
                label: dt.label,
            }))
    }, [hydroStatistics, hydrometryDataTypes])

    const minDateFilterPreview = (date) => {
        const allFirstMeasures = hydroMeasures.flatMap(obj => obj.measures.length ? [obj.measures[0].date] : [])
        return date ?? min(allFirstMeasures) ?? minBy(hydroStatistics, 'startDate')?.startDate ?? moment().subtract(1, 'years').valueOf()
    }
    const { minDate: formattedMinDate, maxDate: formattedMaxDate } = getChartDate(minDateFilterPreview(minDate), maxDate || moment().valueOf(), time, tempRefOffset)

    const mode = hasValue(graphicOptions.maxY) || hasValue(graphicOptions.minY) ? 'manual' : 'auto'

    const icons = [
        { icon: validateImg, toolIcon: VALIDATION, width: 35, tooltip: i18n.validation },
        { icon: purgeImg, toolIcon: PURGE, width: 30, tooltip: i18n.deleting },
        { icon: importImg, toolIcon: IMPORT, width: 30, tooltip: i18n.manualImport, show: !tableView },
        { icon: compensationImg, toolIcon: COMPENSATION, width: 50, tooltip: i18n.compensation, show: !tableView },
        { icon: correctionImg, toolIcon: CORRECTION, width: 45, tooltip: i18n.driftingCorrection, show: !tableView },
        { icon: optionsImg, toolIcon: OPTIONS, width: 35, tooltip: i18n.chartOptions, show: !tableView },
        { icon: thresholdImg, toolIcon: THRESHOLDS, width: 35, tooltip: i18n.thresholds },
        { icon: eventImg, toolIcon: EVENT, width: 35, tooltip: i18n.events },
    ]

    const IconMode = tableView ? FormatListBulleted : MultilineChart

    return (!isLoaded || isNull(dataType)) ? (
        <Grid container size={12} sx={{ padding: '1rem' }}>
            <Grid size={12}>
                <ProgressCard progress={progress * 0.9} round />
            </Grid>
        </Grid>
    ) : (
        <Grid container size={12} padding={1} spacing={1}>
            <Grid size={9}>
                <Card round>
                    <CardContent>
                        <Grid container alignItems='center' justifyContent='flex-start'>
                            <MUIChartTabs
                                offsetHours={tempRefOffset}
                                time={time}
                                onChangeTime={(newTime) => {
                                    setMinDate(newTime.minDate)
                                    setMaxDate(newTime.maxDate)
                                    setTime(newTime.time)
                                }}
                                stationType={STATION_TYPE_NAME.hydrometry}
                                statistics={hydroStatistics}
                            />
                            <Grid paddingLeft={2}>
                                <SimpleChartTabsHydro
                                    displayCote={displayCote}
                                    displayModes={displayModes}
                                    changeDisplayCote={setDisplayCote}
                                    changeDisplayModes={setDisplayModes}
                                    displayModesUniqChoise
                                    changeAccuracy={setAccuracy}
                                    hideAccuracy={false}
                                    withInitialDisplay
                                />
                            </Grid>
                            <Grid paddingLeft={1}>
                                <ChartTempRefChip
                                    tempRef={tempRef}
                                    offsetHours={tempRefOffset}
                                    stationOffsetHours={stationTempRefOffset}
                                    stationTempRefs={hydrometricStation?.link_tempRefs}
                                    onChange={setTempRef}
                                />
                            </Grid>
                            <Grid
                                onClick={() => {
                                    if (isPreview) {
                                        dispatch(ToastrAction.warning(i18n.pleaseSaveModifs))
                                    } else {
                                        setTool(OPTIONS)
                                    }
                                }}
                                sx={{
                                    cursor: 'pointer',
                                    backgroundColor: 'rgba(53, 96, 159, 1)',
                                    color: 'white',
                                    padding: '0px 9px',
                                    borderTop: '2px solid rgba(53, 96, 159, 1)',
                                    borderLeft: '2px solid rgba(53, 96, 159, 1)',
                                    borderRight: '2px solid rgba(53, 96, 159, 1)',
                                    borderRadius: '5px',
                                    marginLeft: 'auto',
                                    marginRight: '20px',
                                    height: '2.7rem',
                                }}
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                            >
                                {i18n.chartScale} : { mode === 'auto' ? i18n.automatic : i18n.manual }
                            </Grid>
                        </Grid>
                        {!dataLoaded ? (
                            <Grid sx={{ padding: '1rem' }}>
                                <ProgressCard indeterminate round />
                            </Grid>
                        ) : !hydroMeasuresFormat.length ? (
                            <Grid sx={{ padding: '1rem' }}>
                                <MessageCard>{i18n.notExistDataPeriod}</MessageCard>
                            </Grid>
                        ) : tableView ? (
                            <Grid sx={{ paddingTop: '1rem' }}>
                                <TableViewValidationHydroMode2
                                    selection={selection}
                                    selectionData={selectionData}
                                    setSelectionData={setSelectionData}
                                    measuresData={hydroMeasures}
                                    sensorValues={sensorValues}
                                    startDate={startDate}
                                    endDate={endDate}
                                    setStartDate={setStartDate}
                                    setEndDate={setEndDate}
                                    minDate={formattedMinDate}
                                    maxDate={formattedMaxDate}
                                    setValue={setValue}
                                    setInitialPoint={setInitialPoint}
                                />
                            </Grid>
                        ) : (
                            <GraphicValidationHydroMode
                                tool={tool}
                                tempRef={tempRef}
                                dataLoaded={dataLoaded}
                                selection={selection}
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                                hydroMeasuresFormat={hydroMeasuresFormat}
                                measuresSelectedByFilters={measuresSelectedByFilters}
                                graphicOptions={graphicOptions}
                                startDate={startDate}
                                endDate={endDate}
                                dataType={dataType}
                                hydroDataTypes={hydroDataTypes}
                                minDate={formattedMinDate}
                                maxDate={formattedMaxDate}
                                addLinePrevious={isPreview}
                                setAddLinePrevious={setIsPreview}
                                isPreview={isPreview}
                                isThresholShow={isThresholShow}
                                serieLinePrevious={serieLinePrevious}
                                setSerieLinePrevious={setSerieLinePrevious}
                                hydrometryThresholds={hydrometryThresholds}
                                contributors={contributors}
                                setValueCorrection={setValueCorrection}
                                measuresChangesValidation={measuresChangesValidation}
                                filterFullDay={{ validationFilterFullDay, setValidationFilterFullDay }}
                                useNGF={useNGF}
                                displayInitialMeasures={displayModes.initialBrute}
                            />
                        )}
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={3}>
                <Card round>
                    <Grid container alignItems='center' spacing={1} sx={{ paddingTop: '10px', paddingLeft: '10px' }}>
                        <Grid size={10}>
                            <SuperMultiAutocomplete
                                values={ dataType }
                                options={ filteredTypesList }
                                label={ i18n.dataType }
                                onChange={ v => {
                                    setSelectedCodePoint(hydrometricStation.link_pointPrels.find(s => s.typeId === v)?.point)
                                    setDataType(v)
                                } }
                                noNullValue
                                noSort
                            />
                        </Grid>
                        <Grid size={2}>
                            <Tooltip
                                placement='top-start'
                                arrow
                                title={tableView ? i18n.graphicMode : i18n.tableMode}
                            >
                                <IconMode
                                    onClick={ () => listView.includes(tool) && setTableView(!tableView) }
                                    sx={{
                                        fontSize: '2.5rem',
                                        color: !listView.includes(tool) ? 'grey' : '#2196F3',
                                        cursor: 'pointer',
                                    }}
                                />
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid container alignItems='center' spacing={1} justifyContent='left' sx={{ paddingTop: '10px', paddingLeft: '10px' }}>
                        <Grid size={10}>
                            <Select
                                value={ selectedCodePoint }
                                options={ hydrometricStation.link_pointPrels.filter(s => s.typeId === dataType) }
                                label={ i18n.pointPrelevement }
                                onChange={ setSelectedCodePoint }
                                noNullValue
                                noSort
                                keyValue='point'
                            />
                        </Grid>
                    </Grid>
                </Card>
                <Card round>
                    <ul style={{ textAlign: 'center', 'margin-top': 5, 'margin-bottom': 5, 'padding-top': 5, 'padding-bottom': 5 }}>
                        {
                            icons.filter(icon => icon.show !== false).map(icon => (
                                <IconTool
                                    key={icon.toolIcon}
                                    icon={icon.icon}
                                    toolIcon={icon.toolIcon}
                                    height={35}
                                    width={icon.width}
                                    tooltip={icon.tooltip}
                                    setTool={(newToolIcon) => isPreview ? dispatch(ToastrAction.warning(i18n.pleaseSaveModifs)) : setTool(newToolIcon)}
                                    iconSelected={tool}
                                    isPreview={isPreview}
                                />
                            ))
                        }
                    </ul>
                </Card>
                <div className='padding-top-1' />
                {tool === VALIDATION && (
                    <ValidationHydroToolPanel2
                        selection={selection}
                        setSelection={setSelection}
                        setSelectionData={setSelectionData}
                        dates={{ startDate, endDate }}
                        value={value}
                        setValue={setValue}
                        initialPoint={initialPoint}
                        setInitialPoint={setInitialPoint}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        setIsChange={setIsChange}
                        isChange={isChange}
                        createTechnicalEvent={createTechnicalEvent}
                        setIsPreview={setIsPreview}
                        isPreview={isPreview}
                        hydroMeasuresFormat={hydroMeasuresFormat}
                        setMeasuresChangesValidation={setMeasuresChangesValidation}
                        measuresChangesValidation={measuresChangesValidation}
                        measuresSelectedByFilters={measuresSelectedByFilters}
                        dataType={dataType}
                        selectedCodePoint={selectedCodePoint}
                        setSelectedCodePoint={setSelectedCodePoint}
                        filterFullDay={{ validationFilterFullDay, setValidationFilterFullDay }}
                        displayModes={displayModes}
                        changeSelectFilters={changeSelectFilters}
                        selectFilters={selectFilters}
                        useNGF={useNGF}
                        landmarkValue={landmarkValue}
                    />
                )}
                {tool === PURGE && (
                    <DeleteHydroToolPanel
                        id={hydrometricStation.id}
                        dataType={dataType}
                        selectedCodePoint={selectedCodePoint}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        setIsChange={setIsChange}
                        isChange={isChange}
                        isPreview={isPreview}
                        setIsPreview={setIsPreview}
                        measuresSelectedByFilters={measuresSelectedByFilters}
                        createTechnicalEvent={createTechnicalEvent}
                        hydroMeasuresFormat={hydroMeasuresFormat}
                        displayModes={displayModes}
                        nextMeasure={nextMeasure}
                        landmarkValue={landmarkValue}
                        useNGF={useNGF}
                        changeSelectFilters={changeSelectFilters}
                        selectFilters={selectFilters}
                    />
                )}
                {tool === COMPENSATION && (
                    <CompensationHydroToolPanel
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        setIsChange={setIsChange}
                        isChange={isChange}
                        createTechnicalEvent={createTechnicalEvent}
                        measuresSelectedByFilters={measuresSelectedByFilters}
                        serieLinePrevious={serieLinePrevious}
                        setSerieLinePrevious={setSerieLinePrevious}
                        setIsPreview={setIsPreview}
                        measuresData={hydroMeasures}
                    />
                )}
                {tool === CORRECTION && (
                    <CorrectionHydroToolPanel
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        setIsChange={setIsChange}
                        isChange={isChange}
                        createTechnicalEvent={createTechnicalEvent}
                        measuresSelectedByFilters={measuresSelectedByFilters}
                        setSerieLinePrevious={setSerieLinePrevious}
                        isPreview={isPreview}
                        setIsPreview={setIsPreview}
                        valueCorrection={valueCorrection}
                        setValueCorrection={setValueCorrection}
                        measuresData={hydroMeasures}
                        serieLinePrevious={serieLinePrevious}
                    />
                )}
                {tool === EVENT && (
                    <EventsToolPanelHydro
                        hydrometricStation={hydrometricStation}
                    />
                )}
                {tool === THRESHOLDS && (
                    <>
                        <ThresholdsTab
                            thresholds={hydrometryThresholds.filter(f => parseInt(f.dataType) == dataType && parseInt(f.stationId) == hydrometricStation.id)}
                            station={hydrometricStation}
                            onReload={() => fetchThresholds()}
                            withoutDataTypeAnnotation
                            selectedDataType={dataType.toString()}
                        />
                        <div style={{ marginTop: 10, backgroundColor: 'white', padding: 5 }}>
                            <Checkbox
                                label={ i18n.displayThresholds }
                                checked={isThresholShow}
                                onChange={() => setIsThresholShow(!isThresholShow)}
                            />
                        </div>
                    </>
                )}
                {tool === IMPORT && (
                    <ImportHydroToolPanel
                        startDate={ startDate }
                        setStartDate={ setStartDate }
                        endDate={ endDate }
                        setEndDate={ setEndDate }
                        applicationSettings={ applicationSettings }
                        selectedDataType={ dataType }
                        id={ hydrometricStation.id }
                        hydrometricStation={ hydrometricStation }
                        hydroMeasuresFormat={ hydroMeasuresFormat }
                        isChange={ isChange }
                        setIsChange={ setIsChange }
                        hydroLastMeasures={ lastMeasureHydro[0] }
                        createTechnicalEvent={createTechnicalEvent}
                    />
                )}
                {tool === OPTIONS && (
                    <SimpleOptionsToolPanel
                        showTitle={false}
                        defaultOptions={graphicOptions}
                        updateState={newGraphicOptions => {
                            const currentOption = hydrometerChartOptions.find(co => co.dataType === `${dataType}`) || {}
                            dispatch(HydrometerStationAction.updateHydrometerChartOptions(hydrometricStation.id, [{
                                ...currentOption,
                                code: hydrometricStation.code,
                                minYear: newGraphicOptions.minY,
                                maxYear: newGraphicOptions.maxY,
                                intervalYear: newGraphicOptions.yIntervalNb,
                                displayXIntervalYear: newGraphicOptions.showXSplitLines ? '1' : '0',
                                displayYIntervalYear: newGraphicOptions.showYSplitLines ? '1' : '0',
                                dataType: `${dataType}`,
                            }])).then(() => setGraphicOptions(prev => ({ ...prev, ...newGraphicOptions })))
                        }}
                    />
                )}
            </Grid>
        </Grid>
    )
}

export default HydrometryValidationApp
